import { render, staticRenderFns } from "./PageMod.vue?vue&type=template&id=d51b2b02&scoped=true"
import script from "./PageMod.vue?vue&type=script&lang=js"
export * from "./PageMod.vue?vue&type=script&lang=js"
import style0 from "./PageMod.vue?vue&type=style&index=0&id=d51b2b02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d51b2b02",
  null
  
)

export default component.exports